import type { QueryClient } from '@tanstack/react-query';

import { createSingleton } from '@luna/utils';

const { get, set } = createSingleton<QueryClient>();

export const getQueryClient = get;
export const setQueryClient = (queryClient: QueryClient): void => {
    set(queryClient);
};
